import { render, staticRenderFns } from "./AddNewConfigurationClassicLinkedin.vue?vue&type=template&id=62607bec&scoped=true&"
import script from "./AddNewConfigurationClassicLinkedin.vue?vue&type=script&lang=js&"
export * from "./AddNewConfigurationClassicLinkedin.vue?vue&type=script&lang=js&"
import style0 from "./AddNewConfigurationClassicLinkedin.vue?vue&type=style&index=0&id=62607bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62607bec",
  null
  
)

export default component.exports